/**
 * Mock XION wallet type
 */
export interface MockWallet {
  address: string;
  connected: boolean;
}

/**
 * Mock balance type
 */
export interface MockBalance {
  denom: string;
  amount: string;
}

/**
 * Mock transaction result
 */
export interface MockTxResult {
  txHash: string;
  success: boolean;
  gasUsed: string;
}

// Internal state
let mockWallet: MockWallet | null = null;

/**
 * Connect to XION wallet (mock)
 * Returns after 500ms delay to simulate network
 */
export async function connecter(): Promise<MockWallet> {
  await delay(500);
  mockWallet = {
    address: 'xion1' + generateRandomHex(38),
    connected: true
  };
  return mockWallet;
}

/**
 * Get wallet balance (mock)
 * Returns after 300ms delay
 */
export async function solde(): Promise<MockBalance> {
  if (!mockWallet?.connected) {
    throw new Error("Portefeuille non connecté! Appelez connecter() d'abord.");
  }
  await delay(300);
  return {
    denom: 'uxion',
    amount: String(Math.floor(Math.random() * 10000000) + 1000000)
  };
}

/**
 * Send tokens (mock)
 * Returns after 800ms delay to simulate transaction
 */
export async function envoyer(
  destinataire: string,
  montant: string,
  denom: string = 'uxion'
): Promise<MockTxResult> {
  if (!mockWallet?.connected) {
    throw new Error("Portefeuille non connecté!");
  }
  await delay(800);
  return {
    txHash: '0x' + generateRandomHex(64),
    success: true,
    gasUsed: String(Math.floor(Math.random() * 100000) + 50000)
  };
}

/**
 * Disconnect wallet (mock)
 */
export async function deconnecter(): Promise<void> {
  await delay(200);
  mockWallet = null;
}

/**
 * Get current wallet (helper)
 */
export function obtenirPortefeuille(): MockWallet | null {
  return mockWallet;
}

/**
 * Check if connected (helper)
 */
export function estConnecte(): boolean {
  return mockWallet?.connected ?? false;
}

// Utility functions
function delay(ms: number): Promise<void> {
  return new Promise(resolve => setTimeout(resolve, ms));
}

function generateRandomHex(length: number): string {
  const chars = '0123456789abcdef';
  let result = '';
  for (let i = 0; i < length; i++) {
    result += chars[Math.floor(Math.random() * chars.length)];
  }
  return result;
}

/**
 * Get all XION mock functions as an object for injection
 */
export function getXionMocks() {
  return {
    connecter,
    solde,
    envoyer,
    deconnecter,
    obtenirPortefeuille,
    estConnecte
  };
}
